module.exports = __webpack_public_path__ + "img/style_3_en.0ee99ee7.jpeg";